// Cloud functionality
import config from "config/config";

// --- Workflow --- //
export const WORKFLOW_CREATE_MAP_STAND_PROJECTION = "map-stand-projection";

// --- URL Paths --- //
// Stand assessment 
export const autoAssessmentGeoJsonGetHeightUrl = config.INTERNAL_API_BASE_URL + "/stand-assessment?";
export const autoAssessmentGeoJsonUrl = config.INTERNAL_API_BASE_URL + "/auto-yield/withgeojson?";
export const autoAssessmentWithHeightUrl = config.INTERNAL_API_BASE_URL +"/auto-yield/withheight?";
export const autoAssessmentWithHeightAndAgeUrl = config.INTERNAL_API_BASE_URL + "/auto-yield/withheightandage?";
export const layersInfoUrl = config.INTERNAL_API_BASE_URL + "/stand-assessment/layers-info?";
// AI-Assistant
export const aiAssistantUrl = config.INTERNAL_API_BASE_URL + "/forsler-clippy";
// Purge feature
export const setFeaturePurgeUrl = config.INTERNAL_API_BASE_URL + "/firestore-get-set/geojson-feature-set-purge?";
// Workflow 
export const invokeWorkflowUrl = config.INTERNAL_API_BASE_URL + "/workflow-ack/invoke?";
export const ackWorkflowUrl = config.INTERNAL_API_BASE_URL + "/workflow-ack/ack?";
